import React, { useEffect, useState } from "react";
import { Link, useParams, Prompt, useHistory } from "react-router-dom";
import {
  getStudentBrand,
  getStudentGradebookCancelToken,
  updatePmcScoreCancelToken,
  updateProgameScore,
  updateProgrammeScore,
} from "../../../../../services/GradeSettingService";
import { GetAssignedSubjectCancelToken } from "../../../../../services/StudentsSettingServices";
import StudentGradeBookTable from "./StudentGradeBookTable";
import { RenderQuizAttemptResultStatus } from "../../../../../utils/CommonStatusItems";
import Str from "../../../../common/Str";
import SkeletonTicketList from "../../../../../loaders/SkeletonTicketList";
import GradeBookSaveBar from "../../../../common/GradeBookSaveBar";
import Swal from "sweetalert2";
import { pdf } from "@react-pdf/renderer";
import moment from "moment";
import { RenderLearningMethodGradebook } from "../../../../../utils/CommonGroupingItem";
import $ from "jquery";
import axios from "axios";
import LetterHeadPDF3 from "../../../../../LetterHeadPDF3";
import { twoDecimalRound } from "../../../../../utils/commonFunction";

function StudentGradeBook({ studentDetails }) {
  const history = useHistory()
  const state = localStorage.getItem("state");
  const brandVisuals = JSON.parse(state).brandVisuals.config;
  const { id } = useParams();
  const [studentGradeBookData, setStudentGradeBookData] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [updateData, setUpdateData] = useState(true);
  const [percentageView, setPercentageView] = useState(false);
  const [IDArray, setIDArray] = useState([]);
  const [pmcIdArr, setPmcIdArr] = useState([]);
  const [gradeMixIDArray, setGradeMixIDArray] = useState([]);
  const [saveGradesLoading, setSaveGradesLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(0);
  const [pdfDownloading, setPdfDownloading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isShowFinal, setIsShowFinal] = useState(false);
  const [isExcludeGrade, setIsExcludeGrade] = useState(false);
  const [brandData, setBrandData] = useState({});
  const [programmeID, setProgrammeID] = useState("");
  const [updateValues, setUpdateValues] = useState({ course: [], gradeMix: [], modules: [] });
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(false);

  useEffect(() => {
    setShouldBlockNavigation(updateValues.course?.length || updateValues.gradeMix?.length || updateValues.modules?.length)
  }, [updateValues])

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (shouldBlockNavigation) {
        event.preventDefault();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldBlockNavigation]);

  useEffect(() => {
    const cancelTokenSources = [];

    const getGradeList = async () => {
      setLoading(true);

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      try {
        const [res, assignedRes] = await Promise.all([
          getStudentGradebookCancelToken(id, source.token),
          GetAssignedSubjectCancelToken(id, source.token),
        ]);
        const exemptionByIntakeId = {};
        if (assignedRes?.status === 200 && Array.isArray(assignedRes.data?.assign_subject)) {
          assignedRes.data.assign_subject.forEach((qual) => {
            (qual.sub_item || []).forEach((c) => {
              if (c.intake_id != null) {
                exemptionByIntakeId[c.intake_id] = Number(c.grant_exemption) === 1 ? 1 : 0;
              }
            });
          });
        }
        if (res.status === 200) {
          let details = res.data?.data || [];
          const isNotEnrolled = (intake) => {
            return (intake?.ModuleId && !intake?.intake);
          };
          const pdfDataWithDetails = Array.isArray(details) && details.length > 0
            ? details.map((course) => ({
              ...course,
              coursesAlongAssessment: Array.isArray(course?.courseWithAssessment) && course.courseWithAssessment.length > 0
                ? course.courseWithAssessment.filter((intake) => !isNotEnrolled(intake))
                .map((intake) => {
                  const intakeId = intake?.intake_id ?? intake?.id;
                  const intakeExempted = exemptionByIntakeId[intakeId] !== undefined
                    ? exemptionByIntakeId[intakeId] === 1
                    : Number(intake?.grant_exemption) === 1;
                  return {
                    course_name: course?.grading_standard == 2
                      ? intake?.name
                      : intake?.course_name || "N/A",
                    weight: intakeExempted
                      ? "Exempted"
                      : (!Array.isArray(intake?.assessments) || intake.assessments.length === 0)
                        ? "N/A"
                        : intake?.weight ?? "N/A",
                    grade: intakeExempted
                      ? "Exempted"
                      : (!Array.isArray(intake?.assessments) || intake.assessments.length === 0)
                        ? "N/A"
                        : (percentageView || intake?.grading_type == 0)
                          ? Math.round(intake?.scoreRecieved || 0) + "%"
                          : intake?.grading_type == 3 &&
                            course?.grading_standard == 2
                            ? `${intake?.allAss_ass_mark ?? 0}/${intake?.allAss_total_mark ?? 0}`
                            : intake?.grading_type == 3 &&
                              course?.grading_standard != 2
                              ? `${intake?.getAssessmentCalculate_sum_ass_mark ?? 0}/${intake?.getAssessmentCalculate_sum_ass_total_mark ?? 0}`
                              : intake?.gradeText || "N/A",
                    result: intakeExempted
                      ? "Exempted"
                      : (!Array.isArray(intake?.assessments) || intake.assessments.length === 0)
                        ? "N/A"
                        : intake?.pass_status
                          ? intake?.pass_status
                          : "N/A",
                    assessments: Array.isArray(intake?.assessments) && intake.assessments.length > 0 ?
                      intake.assessments.map((assessment) => ({
                        name: course?.grading_standard == 2
                          ? assessment?.assessment_name
                          : assessment?.name || "N/A",
                        weight: (Number(assessment?.grant_exemption) === 1 || intakeExempted)
                          ? "Exempted"
                          : assessment?.ass_weighting ?? "N/A",
                        result: (Number(assessment?.grant_exemption) === 1 || intakeExempted)
                          ? "Exempted"
                          : (assessment?.submited == "0" || moment.unix(assessment?.close_date_time) > moment())
                            ? "N/A"
                            : (assessment?.pass_status && assessment.pass_status !== "N/A")
                              ? assessment.pass_status
                              : "N/A",
                        grade: (Number(assessment?.grant_exemption) === 1 || intakeExempted)
                          ? "Exempted"
                          : percentageView
                            ? assessment?.ass_percentage ?? "N/A"
                            : (assessment?.submited == "0" || moment.unix(assessment?.close_date_time) > moment())
                              ? "N/A"
                              : assessment?.grading_type == 3
                                ? `${assessment?.ass_mark ?? 0}/${assessment?.ass_total_mark ?? 0}`
                                : assessment?.gradeText || "N/A",
                        isExclude: !!assessment?.isExclude,
                        isAssignedSickStudent: !!assessment?.isAssignedSickStudent,
                        isSickForThisStudent: !!assessment?.isSickForThisStudent,
                        isSupplementaryForThisStudent: !!assessment?.isSupplementaryForThisStudent,
                      })) : [],
                    final_status: course.programCalculate?.pass_status,
                    final_grade:
                      percentageView || course.programCalculate?.grading_type == 0
                        ? Math.round(course.programCalculate?.scoreRecieved) + "%"
                        : course.programCalculate?.grading_type == 3
                          ? `${course.programCalculate?.programeAssMark}/${course.programCalculate?.programeAssTotalMark}`
                          : course.programCalculate?.gradeText,
                  };
                })
                : [],
              courseWithAssessment: course?.courseWithAssessment?.map((intake) => {
                const intakeId = intake?.intake_id ?? intake?.id;
                const overlayedExemption = exemptionByIntakeId[intakeId] !== undefined
                  ? exemptionByIntakeId[intakeId]
                  : (Number(intake?.grant_exemption) === 1 ? 1 : 0);
                return {
                  ...intake,
                    // intake might be excluded if exempted. Intake only applicable in StuduentGradeBookTable if PMC:
                  intake: intake?.intake ? intake.intake : (intake?.intake_id ? intake?.intake_id : intakeId),
                  course_name: course?.qualificationsLinkedPmc ? intake.Portal : course?.grading_standard == 2 ? intake.name : intake?.course_name,
                  assessments: !Object.hasOwn(intake, "assessments") ? [] : intake?.assessments,
                  showModule: course?.qualificationsLinkedPmc ? 1 : 0,
                  grant_exemption: overlayedExemption
                }
              })
            })) : [];
          setIsEdited(res.data?.allUpdateProgram);
          const gradeMixIDs = details
            ?.filter(item =>
              !item.qualificationsLinkedPmc &&
              item.grading_standard == 2
            ).map(item => item.id);

          const itemIdsArray = details
            ?.filter(item =>
              !item.qualificationsLinkedPmc &&
              (item.grading_standard == 1 || item.grading_standard == 3)
            ).map(item => item.id);
          const PMCIdsArray = (details ?? []).filter(item => item.qualificationsLinkedPmc);
          setIDArray(itemIdsArray);
          setPmcIdArr(PMCIdsArray)
          setGradeMixIDArray(gradeMixIDs)
          setStudentGradeBookData(pdfDataWithDetails);
          setLoading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setLoading(false);
        }
      }
    };

    getGradeList();

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [updateData]);

  useEffect(() => {
    const data = {
      id: [id]
    }
    getStudentBrand(data)
      .then((res) => {
        setBrandData(res?.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const handlepdfData = (programmeId) => {
    setPdfDownloading(true);
    const swalPro = Swal.mixin({
      title: "Downloading PDF",
      text: "Please wait...",
      icon: "info",
      allowOutsideClick: false,
      timerProgressBar: true,
      willOpen: () => {
        Swal.showLoading();
      },
    });
    swalPro.fire();
    const pdfDoc = studentGradeBookData.filter((item) => {
      return item?.id === programmeId;
    });
    if (pdfDoc) {
      let modifiedSoR = pdfDoc[0]?.coursesAlongAssessment
        ?.filter((item) => !item?.course_name?.trim()?.toLowerCase()?.includes("orientation"))
        ?.map((item) => ({
          ...item,
          assessments: isChecked && Array.isArray(item?.assessments)
            ? item.assessments.filter(a => !isExcludeGrade || !a.isExclude)
            : [],
          final_grade: !isShowFinal ? "" : item?.final_grade,
          final_status: !isShowFinal ? "" : item?.final_status,
        }))
        .filter((course) => !isExcludeGrade || !course.isExclude);
      pdf(
        <LetterHeadPDF3
          detailData={modifiedSoR}
          studentAndCourseDetails={{
            program_name: pdfDoc[0]?.program_name,
            Student_name:
              studentDetails.first_name + " " + studentDetails.last_name,
            ID_number: studentDetails?.number,
            Student_number: studentDetails?.student_crm_id
              ? studentDetails?.student_crm_id
              : studentDetails?.student_num,
            start: pdfDoc[0]?.start
              ? pdfDoc[0].start?.toString()?.length == 10
                ? moment.unix(pdfDoc[0]?.start).format("DD MMMM YYYY")
                : moment(pdfDoc[0]?.start).format("DD MMMM YYYY")
              : "",
            end: pdfDoc[0]?.end
              ? pdfDoc[0].end?.toString()?.length == 10
                ? moment.unix(pdfDoc[0]?.end).format("DD MMMM YYYY")
                : moment(pdfDoc[0]?.end).format("DD MMMM YYYY")
              : "",
            intake:
              pdfDoc[0]?.number && pdfDoc[0]?.year
                ? `${pdfDoc[0]?.number}-${pdfDoc[0]?.year}`
                : "",
            learning_method: pdfDoc[0]?.type
              ? RenderLearningMethodGradebook(pdfDoc[0]?.type).text
              : "",
          }}
          brandData={brandData?.getBrandDetail}
        />
      )
        .toBlob()
        .then((response) => {
          const blobURL = window.URL.createObjectURL(response);
          const a = document.createElement("a");
          a.href = blobURL;
          a.download = `${studentDetails?.student_crm_id
              ? studentDetails?.student_crm_id
              : studentDetails?.student_num
            }_${studentDetails.first_name + " " + studentDetails.last_name}_${pdfDoc[0]?.program_name
            }_SOR_${brandVisuals?.brand_name || ""}_${moment(new Date()).format(
              "DD MM YY"
            )}.pdf`; // Set the desired filename for the download
          a.click();

          URL.revokeObjectURL(blobURL);
          setPdfDownloading(false);
          setProgrammeID("")
          setIsChecked(false);
          setIsShowFinal(false);
          setIsExcludeGrade(false);
          swalPro.close();
          $("#availableprogrammeinRereg").modal("hide");
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Download Successfully",
          });
        })
        .catch((err) => {
          setPdfDownloading(false);
          setProgrammeID("")
          setIsChecked(false);
          setIsShowFinal(false);
          setIsExcludeGrade(false);
          swalPro.close();
          $("#availableprogrammeinRereg").modal("hide");
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  const handleShowFinalToggle = () => {
    setIsShowFinal(!isShowFinal);
  };

  const handleExcludeFinal = () => {
    setIsExcludeGrade(!isExcludeGrade);
  };

  const handleSaveGrades = () => {
    setSaveGradesLoading(true);
    const values = {
      id: IDArray,
      student_id: id,
      course: updateValues.course
    };
    const gradxeMixValues = {
      id: gradeMixIDArray,
      student_id: id,
      grademix: updateValues.gradeMix
    }
    const pmcValues = {
      id: [...new Set(pmcIdArr.map(item => item.id))] || [],
      modulesArr: updateValues.modules,
      student_id: id,
      updateFor: "student_gradebook"
    };

    const updateProgrammeScorePromise = gradeMixIDArray?.length
      ? updateProgrammeScore(gradxeMixValues)
      : Promise.resolve();

    const updateProgameScorePromise = IDArray?.length
      ? updateProgameScore(values)
      : Promise.resolve();

    const updatePmcScorePromise = pmcIdArr?.length
      ? updatePmcScoreCancelToken(pmcValues)
      : Promise.resolve();

    Promise.all([updateProgrammeScorePromise, updateProgameScorePromise, updatePmcScorePromise])
      .then((responses) => {
        setSaveGradesLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Updated Successfully",
        }).then((res) => {
          setUpdateData(!updateData);
          setUpdateValues({ course: [], gradeMix: [], modules: [] });
        }
        );
      })
      .catch((err) => {
        setSaveGradesLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
          confirmButtonText: "OK",
        });
      });
  };

  const handleExemption = (assId, val, type, courseId, qId) => {
    if (type) {
      const updatedList = studentGradeBookData.map(program => {
        if (program.id === qId) {
          return {
            ...program,
            courseWithAssessment: program.courseWithAssessment.map(course => {
              if (course.id === courseId) {
                let arr = program.grading_standard === 1 ? updateValues.course : updateValues.gradeMix;
                let idKey = program.grading_standard === 1 ? "intake_id" : "id";
                let ifProgramAndCourseExists = false;

                arr.forEach((item, index) => {
                  if (item[idKey] === courseId && item.qid === qId) ifProgramAndCourseExists = index;
                });

                if (ifProgramAndCourseExists === false) {
                  let updatedObj = {
                    student_id: +id,
                    qid: qId,
                    grant_exemption: val,
                    assessments: []
                  };
                  if (program.grading_standard === 1) updatedObj.intake_id = courseId;
                  else updatedObj.id = courseId;
                  arr.push(updatedObj);
                } else {
                  arr[ifProgramAndCourseExists] = { ...arr[ifProgramAndCourseExists], grant_exemption: val };
                }

                if (program.grading_standard === 1) setUpdateValues(prev => ({ ...prev, course: [...arr] }));
                else setUpdateValues(prev => ({ ...prev, gradeMix: [...arr] }));

                setIsEdited(true);
                return { ...course, grant_exemption: val };
              } else if (course?.ModuleId === courseId) {
                setUpdateValues(prev => {
                  const arr = [...prev.modules];
                  const existingIndex = arr.findIndex(
                    item => item.intake_id === course.intake_id && item.qid === qId
                  );

                  const updatedObj = {
                    grant_exemption: val,
                    intake_id: course.intake_id,
                    pmc_id: program.pmc_id,
                    student_id: id,
                    qid: qId,
                    module_id: course?.ModuleId,
                    version_id: program?.programCalculate?.getProgrameScore?.version_id ?? ""
                  };

                  if (existingIndex >= 0) arr[existingIndex] = { ...arr[existingIndex], ...updatedObj };
                  else arr.push(updatedObj);

                  setIsEdited(true);

                  const updatedValue = { ...prev, modules: arr };
                  return updatedValue;
                });

                return { ...course, grant_exemption: val };
              }

              return course;
            })
          };
        }
        return program;
      });
      setStudentGradeBookData([...updatedList]);
    } else {
      const updatedList = studentGradeBookData.map(program => {
        if (program.id === qId) {
          return {
            ...program,
            courseWithAssessment: program.courseWithAssessment.map(course => {
              if (course.id === courseId) {
                return {
                  ...course,
                  assessments: course.assessments.map(assessment => {
                    if (assessment.assessment_id === assId && course.grant_exemption === 0) {
                      let arr = program.grading_standard === 1 ? updateValues.course : updateValues.gradeMix;
                      let idKey = program.grading_standard === 1 ? "intake_id" : "id";
                      let ifProgramAndCourseExists = false;
                      let ifAssessmentExists = false;

                      arr.forEach((item, index) => {
                        if (item[idKey] === courseId && item.qid === qId) {
                          ifProgramAndCourseExists = index;
                          item.assessments.forEach((ass, ind) => {
                            if (ass.assessment_id === assId) ifAssessmentExists = ind;
                          });
                        }
                      });

                      if (ifProgramAndCourseExists === false) {
                        let updatedObj = {
                          student_id: +id,
                          qid: qId,
                          grant_exemption: 0,
                          assessments: [{ student_id: +id, assessment_id: assId, grant_exemption: val }]
                        };
                        if (program.grading_standard === 1) updatedObj.intake_id = courseId;
                        else updatedObj.id = courseId;
                        arr.push(updatedObj);
                      } else if (ifAssessmentExists === false) {
                        arr[ifProgramAndCourseExists].assessments.push({ student_id: +id, assessment_id: assId, grant_exemption: val });
                      } else {
                        arr[ifProgramAndCourseExists].assessments[ifAssessmentExists] = {
                          ...arr[ifProgramAndCourseExists].assessments[ifAssessmentExists],
                          grant_exemption: val
                        };
                      }

                      if (program.grading_standard === 1) setUpdateValues(prev => ({ ...prev, course: [...arr] }));
                      else setUpdateValues(prev => ({ ...prev, gradeMix: [...arr] }));

                      setIsEdited(true);
                      return { ...assessment, grant_exemption: val };
                    }
                    return assessment;
                  })
                };
              } else if (course?.ModuleId === courseId) {
                const assessmentArr = course.assessments.map(ass =>
                  ass.assessment_id === assId ? { ...ass, grant_exemption: val } : ass
                );

                const updatedAssessment = assessmentArr.find(ass => ass.assessment_id === assId);
                const assessmentToSend = {
                  assessment_id: updatedAssessment.assessment_id,
                  grant_exemption: val,
                  student_id: id,
                };

                setUpdateValues((prev) => {
                  const arr = [...prev.modules];

                  const index = arr.findIndex(
                    (m) => m.intake_id === course.intake_id && m.qid === qId
                  );

                  if (index >= 0) {
                    const existingModule = arr[index];

                    // Ensure assessments array exists
                    const existingAssessments = existingModule.assessments
                      ? [...existingModule.assessments]
                      : [];

                    // Find existing assessment
                    const assIndex = existingAssessments.findIndex(
                      (a) => a.assessment_id === assId
                    );

                    if (assIndex >= 0) {
                      existingAssessments[assIndex] = assessmentToSend;
                    } else {
                      existingAssessments.push(assessmentToSend);
                    }

                    // Update module
                    arr[index] = {
                      ...existingModule,
                      module_id: course?.ModuleId,
                      version_id: program?.programCalculate?.getProgrameScore?.version_id ?? "",
                      assessments: existingAssessments, // FIXED
                    };
                  } else {
                    // Create new module with correct field names
                    arr.push({
                      intake_id: course.intake_id,
                      pmc_id: program.pmc_id,
                      module_id: course?.ModuleId,
                      student_id: id,
                      qid: qId,
                      grant_exemption: course?.grant_exemption,
                      version_id: program?.programCalculate?.getProgrameScore?.version_id ?? "",
                      assessments: [assessmentToSend],
                    });
                  }

                  return { ...prev, modules: arr };
                });
                setIsEdited(true);

                return { ...course, grant_exemption: course?.grant_exemption, assessments: assessmentArr };
              }
              return course;
            })
          };
        }
        return program;
      });
      setStudentGradeBookData([...updatedList]);
    }
  };

  const handleNavigation = (location) => {
    if (shouldBlockNavigation) {
      if (Swal.isVisible()) {
        setUpdateValues({ course: [], gradeMix: [], modules: [] });
        history.push(location.pathname)
        return true;
      }
      Swal.fire({
        title: "Warning",
        text: "You Have Unsaved Changes Left! Do you want to save changes",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No, Leave",
        confirmButtonText: "Yes, Save Changes",
      }).then((value) => {
        if (value.isConfirmed) {
          Swal.fire({
            title: "Please wait",
            text: "Saving changes...",
            allowOutsideClick: false,
            willOpen: () => {
              Swal.showLoading();
              handleSaveGrades()
            },
          }).then(() => {
          });
          setUpdateValues({ course: [], gradeMix: [], modules: [] });
          history.push(location.pathname)
          return true
        } else {
          setUpdateValues({ course: [], gradeMix: [], modules: [] });
          if (location) {
            history.push(location.pathname)
          }
        }
      });
      return false; // Prevent the default navigation behavior
    } else {
      return true
    }
  };

  return loading ? (
    <SkeletonTicketList />
  ) : studentGradeBookData?.length ? (
    <>
      <Prompt when={!!shouldBlockNavigation} message={handleNavigation} />
      <div className="d-flex std-percentage-view">
        <span className="width-full"></span>
        <button
          className="btn btn-primary"
          title={percentageView ? "Standard View" : "Percentage View"}
          onClick={() => setPercentageView(!percentageView)}
        >
          <i className="fal fa-eye"></i>{" "}
          {percentageView ? "Standard View" : "Percentage View"}
        </button>
      </div>
      {studentGradeBookData.map((item, index) => {
        return (
          <div
            key={index}
            className="admin-home-acc accordion ac_over_none"
            id="accordionExample"
          >
            <div className="card-main">
              <div className="card-top">
                <div className="card-header1" id={`heading${item?.id}`}>
                  <h2 className="mb-0">
                    <button
                      className="btn btn-link collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target={`#collapse${item?.id}`}
                      aria-expanded={"false"}
                      aria-controls={`#collapse${item?.id}`}
                    >
                      <div
                        className={
                          `title-border-box ` +
                          (item?.programCalculate?.pass_status == "PASS"
                            ? "pass-side-border-grade"
                            : item?.programCalculate?.pass_status == "FAIL"
                              ? "fail-side-border-grade"
                              : "sideBar-side-border-grade")
                        }
                      >
                        <Link
                          className="curser"
                          to={item?.qualificationsLinkedPmc ? `/program-management-center/programmes/programme/open/${item?.pmc_id}` : `/courseAdministration/Programmes/programme/open/${item?.id}/details`}
                        >
                          <p
                            style={{ color: "#000" }}
                            title={item?.program_name}
                          >
                            {item?.program_name}
                          </p>
                        </Link>
                        <div className="d-flex ml-auto align-items-center">
                          <div>
                            <i className="fal fa-chart-bar mr-2 font-weight-normal"></i>
                            <span className="curser feature-name font-weight-normal">
                              Final Course Grade
                            </span>
                          </div>
                          <div
                            className="resultstatus_flex arrowhide"
                            style={{ marginLeft: "50px" }}
                          >
                            {item?.programCalculate &&
                              item?.programCalculate?.pass_status == "N/A" ? (
                              <span className="mr-2">N/A</span>
                            ) : (
                              <>
                                {percentageView || item.programCalculate?.grading_type == 0 ? (
                                  <span className="font-weight-normal">
                                    {item.programCalculate?.scoreRecieved % 1 === 0 ? item.programCalculate?.scoreRecieved : item.programCalculate?.scoreRecieved.toFixed(2)}%
                                  </span>
                                ) : item.programCalculate?.grading_type == 3 ? (
                                  <>
                                    <span className="font-weight-normal">
                                      {item?.programCalculate?.programeAssMark != null &&
                                        item?.programCalculate?.programeAssTotalMark != null
                                        ? `${twoDecimalRound(item.programCalculate.programeAssMark)}/${item.programCalculate.programeAssTotalMark}`
                                        : ''}
                                    </span>
                                  </>
                                ) : (
                                  <span className="mr-2 font-weight-normal">
                                    {item?.programCalculate?.gradeText}
                                  </span>
                                )}
                                <p className="m-0 mr-2">
                                  {item?.programCalculate?.pass_status
                                    ? RenderQuizAttemptResultStatus(
                                      item?.programCalculate?.pass_status
                                    ).html
                                    : ""}
                                </p>
                              </>
                            )}
                          </div>
                        </div>
                        <button
                          className="btn btn-primary rounded-circle"
                          title="Download SoR PDF"
                          data-toggle="modal"
                          data-target="#availableprogrammeinRereg"
                          onClick={() => setProgrammeID(item?.id)}
                        >
                          {pdfDownloading ? (
                            <i className="fas fa-cog fa-spin download-SoR-icon"></i>
                          ) : (
                            <i className="fal fa-download download-SoR-icon"></i>
                          )}
                        </button>
                      </div>{" "}
                      <div className="header-status">
                        <div className="status-gol card-blue-1">
                          <i className="fal fa-chevron-down rotate-icon"></i>
                        </div>
                      </div>
                    </button>
                  </h2>
                </div>
                <div
                  id={`collapse${item?.id}`}
                  className={`collapse ${false ? "show" : ""}  `}
                  aria-labelledby={`heading${item?.id}`}
                  data-parent="#accordionExample"
                >
                  <div className="card card-body" style={{ border: "0px" }}>
                    <StudentGradeBookTable
                      courseWithAssessmentData={item?.courseWithAssessment}
                      setUpdateData={setUpdateData}
                      updateData={updateData}
                      qid={item.id}
                      ProgramData={item}
                      isWeightShown={
                        item?.grading_method_id == 1 &&
                        item?.aggregation_method_id == 6
                      }
                      iscontributionShown={false}
                      percentageView={percentageView}
                      gradingStandard={item.grading_standard}
                      handleExemption={handleExemption}
                    />
                  </div>
                </div>
              </div>
            </div>
            {(Array.isArray(studentGradeBookData) && studentGradeBookData.length > 0 && isEdited) ? (
              <GradeBookSaveBar
                handleClick={() => handleSaveGrades()}
                disabled={saveGradesLoading}
                saveGradesLoading={saveGradesLoading}
              />
            ) : (
              <></>
            )}
            <div
              className="topic-add-modal modal fade"
              id="availableprogrammeinRereg"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalCenterTitle"
              aria-hidden="true"
              data-backdrop="static"
            >
              <div
                className="modal-600 modal-dialog modal-dialog-centered modal-m"
                role="document"
              >
                <div className="modal-content modal-border-update sor">
                  <div className="modal-body p-0">
                    <div className="modal-header modal-header-custom">
                      <h5 className="modal-title">
                        <i className="fal fa-download"></i> Statement of Results
                        Download Options
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        data-toggle="modal"
                        data-target="#availableprogrammeinRereg"
                        onClick={() => {
                          setProgrammeID("")
                          setIsChecked(false);
                          setIsShowFinal(false);
                          setIsExcludeGrade(false);
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="t p-17px">
                      <i className="fal fa-cog SoR-icon"></i>
                      <span className="SoR-settings"> Settings</span>
                      <div className="toogles-inline mt-3 d-flex align-items">
                        <div className="d-flex align-items mr-3">
                          <label className="mb-0">Show Assessments</label>
                          <div className="toggle-switch ml-2">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleToggle}
                              />
                              <span className="slider slider-round"></span>
                            </label>
                          </div>
                        </div>
                        <div className="d-flex align-items mr-3">
                          <label className="mb-0">Show Final Results</label>
                          <div className="toggle-switch ml-2">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isShowFinal}
                                onChange={handleShowFinalToggle}
                              />
                              <span className="slider slider-round"></span>
                            </label>
                          </div>
                        </div>
                        <div className="d-flex align-items mr-3">
                          <label className="mb-0">Exclude Empty Grades</label>
                          <div className="toggle-switch ml-2">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={isExcludeGrade}
                                onChange={handleExcludeFinal}
                              />
                              <span className="slider slider-round"></span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="form-group form-group-save-cancel mt-4">
                        <button
                          className="btn btn-save btn-success"
                          type="submit"
                          title="Save"
                          onClick={() => handlepdfData(programmeID)}
                        >
                          <i className="fal fa-download"></i> Download SoR
                        </button>
                        <button
                          className="btn btn-close btn-danger"
                          type="button"
                          title="Cancel"
                          onClick={() => {
                            setIsChecked(false);
                            setIsShowFinal(false);
                            setIsExcludeGrade(false);
                            setProgrammeID("")
                            $("#availableprogrammeinRereg").modal("hide");
                          }}
                        >
                          <i className="fal fa-times"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  ) : (
    <div className="custom-table-msg">{Str.noRecord}</div>
  );
}

export default StudentGradeBook;
